/**
 * A coach's profile is the app's own, /coach/:id, wherever it is opened from
 * (Ryan, 29 Oct). The app never sends the browser to the CMS's coach page:
 * that full page load to another host is the tap iOS Safari hands to the
 * installed native app, and the CMS page has no live offers.
 */
export function coachProfilePath(coachId: string, hash?: string): string {
  return `/coach/${coachId}${hash ? `#${hash}` : ''}`;
}
